// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Header Styling */
.header {
    background-color: black;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* Logo */
.logo-container {
    display: flex;
    align-items: center;
}

.logo {
    height: 50px;
    width: auto;
}

/* Desktop Navigation */
.nav-menu {
    display: flex;
}

.nav-menu ul {
    display: flex;
    gap: 20px;
    list-style: none;
}

.nav-menu ul li a {
    text-decoration: none;
    color: white;
    font-weight: bold;
    padding: 10px;
}

/* Mobile Menu Styles */
.menu-toggle {
    display: none;
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
}

/* Responsive Design */
@media (max-width: 768px) {

    /* Show hamburger button */
    .menu-toggle {
        display: block;
    }

    /* Dropdown menu */
    .nav-menu {
        position: absolute;
        top: 60px;
        right: 0;
        background-color: rgba(0, 0, 0, 0.9);
        /* Dark semi-transparent background */
        width: 220px;
        display: none;
        flex-direction: column;
        text-align: center;
        padding: 10px 0;
        border-radius: 5px;
        box-shadow: 0px 4px 8px rgba(255, 255, 255, 0.2);
    }

    .nav-menu.open {
        display: flex;
    }

    .nav-menu ul {
        flex-direction: column;
        padding: 0;
        margin: 0;
    }

    /* .nav-menu ul li {
        margin: 10px 0;
    } */

    .nav-menu ul li a {
        display: block;
        color: white;
        padding: 12px 15px;
        text-decoration: none;
        font-weight: bold;
        background-color: #333;
        /* Dark background for each menu item */
        border-radius: 5px;
        transition: background 0.3s ease;
    }

    .nav-menu ul li a:hover {
        background-color: #555;
        /* Lighter shade for hover effect */
    }
}`, "",{"version":3,"sources":["webpack://./src/header/Header.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,SAAS;AACT;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA,sBAAsB;AACtB;;IAEI,0BAA0B;IAC1B;QACI,cAAc;IAClB;;IAEA,kBAAkB;IAClB;QACI,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,oCAAoC;QACpC,qCAAqC;QACrC,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gDAAgD;IACpD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,UAAU;QACV,SAAS;IACb;;IAEA;;OAEG;;IAEH;QACI,cAAc;QACd,YAAY;QACZ,kBAAkB;QAClB,qBAAqB;QACrB,iBAAiB;QACjB,sBAAsB;QACtB,uCAAuC;QACvC,kBAAkB;QAClB,gCAAgC;IACpC;;IAEA;QACI,sBAAsB;QACtB,mCAAmC;IACvC;AACJ","sourcesContent":["/* General Header Styling */\n.header {\n    background-color: black;\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n/* Logo */\n.logo-container {\n    display: flex;\n    align-items: center;\n}\n\n.logo {\n    height: 50px;\n    width: auto;\n}\n\n/* Desktop Navigation */\n.nav-menu {\n    display: flex;\n}\n\n.nav-menu ul {\n    display: flex;\n    gap: 20px;\n    list-style: none;\n}\n\n.nav-menu ul li a {\n    text-decoration: none;\n    color: white;\n    font-weight: bold;\n    padding: 10px;\n}\n\n/* Mobile Menu Styles */\n.menu-toggle {\n    display: none;\n    background: none;\n    border: none;\n    color: white;\n    font-size: 24px;\n    cursor: pointer;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n\n    /* Show hamburger button */\n    .menu-toggle {\n        display: block;\n    }\n\n    /* Dropdown menu */\n    .nav-menu {\n        position: absolute;\n        top: 60px;\n        right: 0;\n        background-color: rgba(0, 0, 0, 0.9);\n        /* Dark semi-transparent background */\n        width: 220px;\n        display: none;\n        flex-direction: column;\n        text-align: center;\n        padding: 10px 0;\n        border-radius: 5px;\n        box-shadow: 0px 4px 8px rgba(255, 255, 255, 0.2);\n    }\n\n    .nav-menu.open {\n        display: flex;\n    }\n\n    .nav-menu ul {\n        flex-direction: column;\n        padding: 0;\n        margin: 0;\n    }\n\n    /* .nav-menu ul li {\n        margin: 10px 0;\n    } */\n\n    .nav-menu ul li a {\n        display: block;\n        color: white;\n        padding: 12px 15px;\n        text-decoration: none;\n        font-weight: bold;\n        background-color: #333;\n        /* Dark background for each menu item */\n        border-radius: 5px;\n        transition: background 0.3s ease;\n    }\n\n    .nav-menu ul li a:hover {\n        background-color: #555;\n        /* Lighter shade for hover effect */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
